import dayjs from 'dayjs';

import { ActivityAnalyzeRangeFilters } from 'business/shift-report/report-analyze/pages/activity-analyze/providers/filters/types';
import {
  ACTIVITY_GROUP_BY_TYPES_MAP,
  ReportActivityAnalyzeGraphPoint,
} from 'business/shift-report/report-analyze/pages/activity-analyze/types';
import { GetReportActivityAnalyzeV1ResponseDto } from 'generated/apiSchemas';
import { addMissingDaysForGraphPerDay } from 'technical/graph/add-missing-days-for-graph-per-day';
import { formatDateToDayAndMonth } from 'technical/time-utils/format-date-to-day-and-month';

const GROUP_TYPE_TO_DATA_MAPPER = {
  [ACTIVITY_GROUP_BY_TYPES_MAP.day]: (date: string | Date) =>
    formatDateToDayAndMonth(date),
  [ACTIVITY_GROUP_BY_TYPES_MAP.week]: (date: string) =>
    dayjs(date).format('wo YYYY'),
  [ACTIVITY_GROUP_BY_TYPES_MAP.month]: (date: string) =>
    dayjs(date).format('MMM YYYY'),
  [ACTIVITY_GROUP_BY_TYPES_MAP.report]: (date: string, shiftName?: string) =>
    `${dayjs(date).format('L')} - ${shiftName}`,
  [ACTIVITY_GROUP_BY_TYPES_MAP.ring]: (ring: string) => ring,
};

export const formatData = (
  graphData: GetReportActivityAnalyzeV1ResponseDto['graphData'] | undefined,
  filters: ActivityAnalyzeRangeFilters,
): ReportActivityAnalyzeGraphPoint[] => {
  const { filterType, groupByType } = filters;

  if (!graphData) {
    return [];
  }

  if (groupByType === ACTIVITY_GROUP_BY_TYPES_MAP.activity) {
    return graphData;
  }

  if (
    filterType === 'date' &&
    groupByType === ACTIVITY_GROUP_BY_TYPES_MAP.day
  ) {
    const filledGraphData = addMissingDaysForGraphPerDay(
      filters.dateRange,
      graphData.map(({ rowDisplay, ...rest }) => ({
        date: dayjs(rowDisplay).toDate(),
        ...rest,
      })),
      (date) => ({
        date: dayjs(date).toDate(),
      }),
    );

    return filledGraphData.map(({ date, ...rest }) => ({
      rowDisplay:
        GROUP_TYPE_TO_DATA_MAPPER[ACTIVITY_GROUP_BY_TYPES_MAP.day](date),
      ...rest,
    }));
  }

  return graphData.map(({ rowDisplay, rowDisplayShiftName, ...rest }) => ({
    rowDisplay: GROUP_TYPE_TO_DATA_MAPPER[groupByType](
      // Assert because rowDisplay is always defined for groupByType other than activity
      rowDisplay!,
      rowDisplayShiftName,
    ),
    ...rest,
  }));
};
